import { Component, Input, ViewChild} from '@angular/core';
import { Subscription } from 'rxjs';
import { SdVoteId, sdVoteOption } from '../../../../../../shared/constants/sd-ballot.constants';
import { ViewVoteIconsConstants } from '../../../../../../shared/constants/view-vote-icons-constants';
import { ViewVotesPopoverComponent } from '../../../../shared/components/view-votes-popover/view-votes-popover.component';
import { VotesDocumentsPopoverComponent } from '../../../../shared/components/votes-documents-popover/votes-documents-popover.component';
import { ISdVoteDto } from '../../../../shared/models/sd/sd-vote';
import { IVotePopoverItem } from '../../../../shared/models/vote-popover-item';
import { BallotUri } from '../../../../shared/services/ballot-document.service';
import { SdBallotService } from '../../../../shared/services/sd-ballot.service';


@Component({
    selector: 'app-srs-vote-column',
    templateUrl: './sd-vote-column.component.html',
    styleUrl: './sd-vote-column.component.scss',
    standalone: false
})
export class SdVoteColumnComponent {
  @ViewChild('commentPopover') commentPopover!: ViewVotesPopoverComponent;
  @ViewChild('historyPopover') historyPopover!: ViewVotesPopoverComponent;
  @Input() vote: ISdVoteDto | null = null;
  @Input() isUserPmOrAboveOrHoSD: boolean = false;
  @Input() isUserCM: boolean = false;
  @Input() loginUserEmail: string = '';

  subscriptions: Subscription = new Subscription();
  voteCommentPopoverItems: IVotePopoverItem[] = [];
  voteHistoryPopoverItems: IVotePopoverItem[] = [];


  public readonly ViewVoteIconsConstants = ViewVoteIconsConstants;

  iconName: string = '';
  colorClass: string = '';
  hasComment: boolean = false;
  hasDocument: boolean = false;
  hasHistories: boolean = false;
  showingDocumentIcon: boolean = false;
  isEligibleVoter: boolean = false;


  constructor(private _sdBallotService: SdBallotService) {
  }

  BallotType = BallotUri.SD;

  ngOnInit(): void {
    const voteId = this.vote?.voteId;
    this.isEligibleVoter = this.vote?.isEligible ?? false;
    if (this.vote) {
      if(this.isEligibleVoter) {
        this.checkVoteType(voteId as SdVoteId);
        this.checkComment(this.vote);
        this.checkDocument(this.vote);
        this.checkHistories(this.vote);
        this.checkUserVote(this.vote);
      } else {
        this.checkComment(this.vote);
      }
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  checkVoteType(voteId: SdVoteId): void {
    this.iconName = sdVoteOption[voteId].icon;
    this.colorClass = sdVoteOption[voteId].color;
  }

  checkComment(vote: ISdVoteDto): void {
    this.hasComment = vote.hasCommented;
  }

  checkDocument(vote: ISdVoteDto): void {
    this.hasDocument = vote.hasDocument;
  }

  openVoteDocumentsPopover(popover: VotesDocumentsPopoverComponent) {
    popover.openPopover();
  }

  checkHistories(vote:ISdVoteDto): void{
    this.hasHistories = vote.hasHistories;
  }

  checkUserVote(vote: ISdVoteDto) {
    if (this.isUserPmOrAboveOrHoSD) {
      this.showingDocumentIcon = this.hasDocument;
    } else if (this.isUserCM) {
      const voterEmail = vote.email;
      if (voterEmail?.trim() && this.loginUserEmail?.trim()) {
        this.showingDocumentIcon =
          voterEmail.toLowerCase() == this.loginUserEmail?.toLowerCase() &&
          this.hasDocument;
      } else {
        this.showingDocumentIcon = false;
      }
    }
  }


  openPopover(popover: ViewVotesPopoverComponent) {
    this.getVotePopoverItems();
    popover.openPopover();
  }

  getVotePopoverItems(): void {
    this.voteCommentPopoverItems = [];
    this.voteHistoryPopoverItems = [];

    if ((this.hasComment || this.hasHistories) && this.vote && this.vote.ballotRecordId && this.vote.ballotVoteId) {
      this.subscriptions.add(this._sdBallotService.getSdBallotVoteHistory(this.vote.ballotRecordId, this.vote.ballotVoteId).subscribe({
        next: (response) => {
          if (response && response.success) {
            this.voteCommentPopoverItems = response.content
              .filter((comment) => (comment.voteResult in SdVoteId) && comment.ballotComment?.trim() !== '')
              .map((comment) => {

                const voteResult = sdVoteOption[comment.voteResult as SdVoteId];
                const popoverItem : IVotePopoverItem = {
                  voteOption: voteResult,
                  additionalComments: comment.ballotComment,
                  voteSubmittedDate: comment.lastUpdated
                };

                return popoverItem;
            });

            this.voteHistoryPopoverItems = response.content
              .filter((comment) => (comment.voteResult in SdVoteId))
              .map((comment) => {
                const voteResult = sdVoteOption[comment.voteResult as SdVoteId];
                const popoverItem : IVotePopoverItem = {
                  voteOption: voteResult,
                  voteSubmittedDate: comment.lastUpdated,
                  additionalComments: null
                };

                return popoverItem;
            });
          } else {
            console.error('Error fetching vote history.', response.message);
          }
        },
        error: (error) => {
          console.error('Error fetching vote history.', error);
        }
      }));
    }
  }
}

